import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const createForQualityAssuranceOrder = (data) => apiActionCreator({
  'endpoint': '/quality-assurance/orders',
  'authenticated': true,
  'types': [
    ActionTypes.CREATING_QUALITY_ASSURANCE_ORDER,
    [
      ActionTypes.CREATED_QUALITY_ASSURANCE_ORDER,
      (response) => MessageActions.addMessageBoxInfo(`Order ${response.order} creada satisfactoriamente`),
    ],
    [
      ActionTypes.CREATED_QUALITY_ASSURANCE_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  data,
});
